import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import PreviewLayout from 'layout/PreviewLayout';

const PreviewAiTripPlan = Loadable(lazy(() => import('views/public/preview-ai-trip')));
const StreamView = Loadable(lazy(() => import('views/stream/StreamView')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const PublicRoutes = {
  path: '/preview',
  element: <PreviewLayout />,
  children: [
    {
      path: 'ai-trip',
      element: <PreviewAiTripPlan />
    },
    {
      path: 'stream',
      element: <StreamView />
    }
  ]
};

export default PublicRoutes;
